import { useIsNewFeatureTagActive } from "@src/hooks/useNewFeatureTags";
import React, { CSSProperties } from "react";
import { clx } from "../utils/stringUtils";
import styles from "./NewTag.module.scss";

type TOffset = number | string;

export interface INewTagProps {
	tagId: string;
	isCollapsed?: boolean;
	label?: string;
	className?: string;
	style?: CSSProperties;
	top?: TOffset;
	right?: TOffset;
	bottom?: TOffset;
	left?: TOffset;
}

const toCssOffset = (value?: TOffset) => (typeof value === "number" ? `${value}px` : value);

export const NewTag: React.FC<INewTagProps> = ({
	tagId,
	isCollapsed = false,
	label = "New",
	className,
	style,
	top,
	right,
	bottom,
	left,
}) => {
	const isActive = useIsNewFeatureTagActive(tagId);

	if (!isActive) return null;

	const hasOffset = [top, right, bottom, left].some((offset) => offset !== undefined);

	const positionStyle: CSSProperties = hasOffset
		? {
				position: "absolute",
				top: toCssOffset(top),
				right: toCssOffset(right),
				bottom: toCssOffset(bottom),
				left: toCssOffset(left),
			}
		: {};

	return (
		<span
			data-tag-id={tagId}
			aria-label={isCollapsed ? label : undefined}
			className={clx({
				[styles.root]: true,
				[styles.collapsed]: isCollapsed,
				[className ?? ""]: !!className,
			})}
			style={{ ...positionStyle, ...style }}>
			{isCollapsed ? null : label}
		</span>
	);
};
